import type { IDefaultAPIState } from 'types/state.interface';

/**
 * standardized way of deleting an entity from the redux state
 */
export const deleteEntityFromState = (
  id: string | number,
  state: IDefaultAPIState,
  idKey = 'id'
): void => {
  const { [id]: _, ...updState } = state.map;
  state.map = updState;
  const idx = state.results.findIndex(
    (el) => el && el[idKey].toString() === id.toString()
  );
  if (idx > -1)
    state.results = [
      ...state.results.slice(0, idx),
      ...state.results.slice(idx + 1),
    ];
};
